import React from 'react'
import s from './DeadlinePill.module.scss'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const formatDate = value => {
	if (!value) return '—'
	const dt = new Date(value)
	if (Number.isNaN(dt.getTime())) return String(value)
	return `${MONTHS[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`
}

const computeTone = days => {
	if (days == null) return 'safe'
	if (days < 0) return 'urgent'
	if (days <= 7) return 'urgent'
	if (days <= 30) return 'soon'
	return 'safe'
}

const computeLabel = days => {
	if (days == null) return '—'
	if (days < 0) return `${Math.abs(days)} days overdue`
	if (days === 0) return 'Due today'
	if (days === 1) return '1 day left'
	return `${days} days left`
}

const daysUntil = value => {
	if (!value) return null
	const dt = new Date(value)
	if (Number.isNaN(dt.getTime())) return null
	const now = new Date()
	const ms = dt.getTime() - now.getTime()
	return Math.ceil(ms / (1000 * 60 * 60 * 24))
}

const DeadlinePill = ({ deadline }) => {
	const days = daysUntil(deadline)
	const tone = computeTone(days)

	return (
		<div className={s.wrap}>
			<span className={s.date}>{formatDate(deadline)}</span>
			<span className={`${s.pill} ${s[tone]}`}>{computeLabel(days)}</span>
		</div>
	)
}

export default DeadlinePill
